import React, {Component} from 'react';

class InterviewQues extends Component {
  render() {
    const { interviewQuesVOs, handleClick, selectedIndex } = this.props;
    return (
      <ul className="interviewQues">
        {interviewQuesVOs && interviewQuesVOs.map((item, index) => (
          <li key={index} onClick={() => handleClick(item.questionId, index)} className={`${selectedIndex === index ? 'active' : ''}`}>
              <p>Q{index + 1}</p>
          </li>
        ))}
      </ul>
    );
  }
}

export default InterviewQues;
